import { z } from "zod";

// PUT …/rooms/update: data is the number of updated rooms
export const coreUpdateRoomsResponseSchema = z.object({
    error: z.unknown().nullable().optional(),
    data: z.number()
});
